import { DEFAULT_PAGE_SIZE } from '../../config'
import ApiClient from '../apiClient'
import { getUserId } from '../user'

const client = new ApiClient()

const uploadTaxReturnInput = ({ userId = getUserId(), file, type }) => {
  return client.post(`/input/users/${userId}/tax-returns/ocr-service`, {
    data: { file, type },
  })
}

const getTaxReturnInputs = ({
  userId = getUserId(),
  page = 1,
  per_page = DEFAULT_PAGE_SIZE,
}) => {
  return client.get(`/input/users/${userId}/tax-returns`, {
    params: { page, per_page },
  })
}

const inputService = {
  uploadTaxReturnInput,
  getTaxReturnInputs,
}

export default inputService
